import React from 'react';
import { EditCloseIcon } from '@/utils/svgIcons';
import { useRouter } from 'next/router';
import { usePersonalizeModal } from '@/contexts/PersonalizeModalContext'; // Import context

export default function PersonalizeHeader({
  step,
  productData,
  childName,
  setPersonalizeModal,
  setStep,
  setActiveOption
}: any) {
  const { locale } = useRouter();
  
  const DemoName = locale == 'ar' 
    ? productData?.product?.demo_name?.ar 
    : productData?.product?.demo_name?.en;
  
  return (
    <div className="flex justify-between items-center px-4 py-3 border-b shadow-sm">
      <div className="w-6" /> {/* Spacer to center title */}
      {typeof DemoName === 'string' && (
        <h2 className={`${step === 'review' ? 'text-2xl': 'text-base'} text-black mx-auto`}>
          {DemoName.split('{basmti}')[0]}
          <span className="text-success-500">
            {childName} {/* Will update in real-time */}
          </span>
          {DemoName.split('{basmti}')[1]}
        </h2>
      )}

      {(step === 'info' || step === 'edit') && (
        <button 
          className="bg-[#93A3B03D] text-xl p-2 rounded-md" 
          onClick={() => {
            if(step === 'info') {
              setPersonalizeModal(false);
            }
            if(step === 'edit'){
              setStep('review');
              setActiveOption('');
            }
          }}
        >
          <EditCloseIcon/>
        </button>
      )}
    </div>
  );
}